export const CLIENT_AREA_PERMISSIONS = {
	access: 'clientArea.access',
	manageDocuments: 'clientArea.manageDocuments',
	manageCategories: 'clientArea.manageCategories',
} as const;

export type ClientAreaPermission =
	typeof CLIENT_AREA_PERMISSIONS[keyof typeof CLIENT_AREA_PERMISSIONS];
